/* Landing-page product logic: variants, bundle tiers, subscriptions, honest countdown, sticky ATC. */
(function () {
  'use strict';
  if (window.__lpLoaded) return; // script may be included by several sections
  window.__lpLoaded = true;

  function money(cents, currency) {
    try {
      return new Intl.NumberFormat('en-US', { style: 'currency', currency: currency || 'USD' }).format(cents / 100);
    } catch (e) {
      return '$' + (cents / 100).toFixed(2);
    }
  }

  function pad(n) { return String(n).padStart(2, '0'); }

  function formatLeft(sec) {
    var d = Math.floor(sec / 86400), h = Math.floor((sec % 86400) / 3600), m = Math.floor((sec % 3600) / 60), s = sec % 60;
    if (d > 0) return d + 'd ' + pad(h) + 'h ' + pad(m) + 'm';
    if (h > 0) return h + 'h ' + pad(m) + 'm ' + pad(s) + 's';
    return pad(m) + 'm ' + pad(s) + 's';
  }

  // Seconds until today's cutoff hour in the given timezone (null if already past).
  function secondsToCutoff(hour, tz) {
    var parts = {};
    try {
      new Intl.DateTimeFormat('en-US', { timeZone: tz, hour12: false, hour: '2-digit', minute: '2-digit', second: '2-digit', weekday: 'short' })
        .formatToParts(new Date()).forEach(function (p) { parts[p.type] = p.value; });
    } catch (e) { return null; }
    if (parts.weekday === 'Sat' || parts.weekday === 'Sun') return null;
    var nowSec = (parseInt(parts.hour, 10) % 24) * 3600 + parseInt(parts.minute, 10) * 60 + parseInt(parts.second, 10);
    var left = hour * 3600 - nowSec;
    return left > 0 ? left : null;
  }

  // Sale end typed in the editor: "2026-10-29 23:59" (or just "2026-10-29" = end of that day) in the store timezone; full ISO dates still work.
  function parseEnd(str, tz) {
    var m = String(str).trim().match(/^(\d{4})-(\d{2})-(\d{2})(?:[ T](\d{1,2}):(\d{2}))?$/);
    if (!m) return new Date(str).getTime();
    var guess = Date.UTC(+m[1], +m[2] - 1, +m[3], m[4] ? +m[4] : 23, m[5] ? +m[5] : 59);
    try {
      var p = {};
      new Intl.DateTimeFormat('en-US', { timeZone: tz, hour12: false, year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit' })
        .formatToParts(new Date(guess)).forEach(function (x) { p[x.type] = x.value; });
      var asTz = Date.UTC(+p.year, +p.month - 1, +p.day, +p.hour % 24, +p.minute);
      return guess - (asTz - guess); /* shift by the zone's offset */
    } catch (e) { return guess; }
  }

  function initCountdown(el) {
    var mode = el.dataset.mode;
    var textEl = el.querySelector('[data-lp-countdown-text]');
    var end = mode === 'deadline' && el.dataset.end ? parseEnd(el.dataset.end, el.dataset.tz || 'America/New_York') : null;
    if (mode === 'deadline' && (!end || isNaN(end))) return;

    function tick() {
      var left = null;
      if (mode === 'deadline') {
        left = Math.floor((end - Date.now()) / 1000);
        if (left <= 0) left = null;
      } else {
        left = secondsToCutoff(parseInt(el.dataset.cutoff, 10) || 14, el.dataset.tz || 'America/New_York');
      }
      if (left === null) {
        if (mode === 'deadline' || !el.dataset.after) { el.hidden = true; return false; }
        textEl.textContent = el.dataset.after;
      } else {
        var before = el.dataset.before || '[time]';
        textEl.innerHTML = '';
        var bits = before.split('[time]');
        textEl.appendChild(document.createTextNode(bits[0]));
        var strong = document.createElement('strong');
        strong.className = 'lp-countdown__time';
        formatLeft(left).split(' ').forEach(function (part) { /* "10h" → tile with number + small unit */
          var u = document.createElement('span'); u.className = 'lp-countdown__unit';
          u.appendChild(document.createTextNode(part.slice(0, -1)));
          var sm = document.createElement('small'); sm.textContent = part.slice(-1); u.appendChild(sm);
          strong.appendChild(u);
        });
        textEl.appendChild(strong);
        if (bits[1]) textEl.appendChild(document.createTextNode(bits[1]));
      }
      el.hidden = false;
      return true;
    }
    if (tick()) {
      var timer = setInterval(function () { if (!tick()) clearInterval(timer); }, 1000);
    }
  }

  function initProduct(root) {
    var dataEl = root.querySelector('[data-lp-json]');
    if (!dataEl) return;
    var data = JSON.parse(dataEl.textContent);
    var cur = data.currency;
    var idInput = root.querySelector('[data-lp-id]');
    var qtyInput = root.querySelector('[data-lp-qty]');
    var planInput = root.querySelector('[data-lp-plan]');
    var atc = root.querySelector('[data-lp-atc]');
    var atcText = root.querySelector('[data-lp-atc-text]');
    var stockEl = root.querySelector('[data-lp-stock]');
    var track = root.querySelector('[data-lp-track]');
    var thumbs = root.querySelectorAll('[data-lp-thumb]');
    var slides = track ? track.children : [];
    var optionSets = root.querySelectorAll('[data-lp-option]');
    var packs = root.querySelector('.lp-packs');
    var tierInputs = root.querySelectorAll('.lp-tier input');
    var sticky = root.querySelector('[data-lp-sticky]');

    function selectedOptions() {
      return Array.prototype.map.call(optionSets, function (fs) {
        var c = fs.querySelector('input:checked');
        return c ? c.value : null;
      });
    }

    function currentVariant() {
      if (!optionSets.length) return data.variants[0];
      var sel = selectedOptions();
      return data.variants.find(function (v) {
        return v.options.every(function (o, i) { return o === sel[i]; });
      }) || null;
    }

    function currentTier() {
      var t = root.querySelector('.lp-tier input:checked');
      return t ? { qty: parseInt(t.value, 10), disc: parseInt(t.dataset.discount, 10) || 0, free: parseInt(t.dataset.free, 10) || 0 } : { qty: 1, disc: 0, free: 0 };
    }

    // ---- Gallery ----
    /* slides can be hidden / reordered per pack card, so navigation works on the visible slides */
    var thumbWrap = root.querySelector('.lp-gallery__thumbs');
    function keyOf(el) { return (el.dataset.key || '').replace(/_[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i, ''); }
    function visSlides() { return Array.prototype.filter.call(slides, function (s) { return !s.hidden; }); }
    function goToEl(el, instant) {
      if (el) track.scrollTo({ left: el.offsetLeft, behavior: instant ? 'auto' : 'smooth' });
    }
    function goTo(i, instant) { goToEl(slides[i], instant); }
    function activeEl() {
      var v = visSlides();
      return v[Math.round(track.scrollLeft / (track.clientWidth || 1))] || v[0];
    }
    function activeIndex() {
      return track ? Array.prototype.indexOf.call(slides, activeEl()) : 0;
    }
    function step(d) {
      var v = visSlides(), i = v.indexOf(activeEl());
      goToEl(v[Math.min(v.length - 1, Math.max(0, i + d))]);
    }
    if (track) {
      thumbs.forEach(function (b) {
        b.addEventListener('click', function () {
          var k = b.dataset.key;
          goToEl(k ? Array.prototype.find.call(slides, function (s) { return s.dataset.key === k; }) : slides[+b.dataset.lpThumb]);
        });
      });
      var prev = root.querySelector('[data-lp-prev]'), next = root.querySelector('[data-lp-next]');
      if (prev) prev.addEventListener('click', function () { step(-1); });
      if (next) next.addEventListener('click', function () { step(1); });
      var raf;
      track.addEventListener('scroll', function () {
        cancelAnimationFrame(raf);
        raf = requestAnimationFrame(function () {
          var a = activeEl();
          /* load the shown slide and the next two now, lazy-loading is late inside the scroller on phones */
          var v = visSlides(), ai = v.indexOf(a);
          v.slice(Math.max(0, ai), ai + 3).forEach(function (s) {
            s.querySelectorAll('img[loading="lazy"]').forEach(function (im) { im.loading = 'eager'; });
          });
          thumbs.forEach(function (t, k) {
            t.classList.toggle('is-active', a ? (t.dataset.key ? t.dataset.key === a.dataset.key : slides[k] === a) : false);
          });
          Array.prototype.forEach.call(slides, function (s) {
            var vid = s.querySelector('video');
            if (vid) { if (s === a) vid.play().catch(function () {}); else vid.pause(); }
          });
        });
      }, { passive: true });
    }

    /* "Gallery per card" setting: Card name = file, file, clip:name */
    var packMedia = {};
    (data.packMedia || '').split(/\r?\n/).forEach(function (line) {
      var eq = line.indexOf('=');
      if (eq < 0) return;
      packMedia[line.slice(0, eq).trim().toLowerCase()] = line.slice(eq + 1).split(',')
        .map(function (s) { return s.trim(); }).filter(Boolean);
    });
    function applyPack(v) {
      var list = track && v && packMedia[String(v.options[0] || '').toLowerCase()];
      if (!list) return false;
      var sByKey = {}, tByKey = {};
      Array.prototype.slice.call(slides).forEach(function (s) { sByKey[keyOf(s)] = s; s.hidden = true; });
      thumbs.forEach(function (t) { tByKey[keyOf(t)] = t; t.hidden = true; });
      list.forEach(function (k) {
        var s = sByKey[k];
        if (!s) return;
        s.hidden = false;
        track.appendChild(s);
        if (tByKey[k]) { tByKey[k].hidden = false; if (thumbWrap) thumbWrap.appendChild(tByKey[k]); }
      });
      if (!visSlides().length) Array.prototype.forEach.call(slides, function (s) { s.hidden = s.classList.contains('lp-gallery__slide--clip'); });
      /* a lazy image moved to the front is not always picked up again by the browser: load the first ones now */
      visSlides().slice(0, 2).forEach(function (s) {
        s.querySelectorAll('img[loading="lazy"]').forEach(function (im) { im.loading = 'eager'; });
      });
      return true;
    }

    // ---- Zoom lightbox (images only) ----
    var zoomSlides = Array.prototype.filter.call(slides, function (s) { return s.dataset.zoom; });
    function openZoom(startSlide) {
      if (!zoomSlides.length) return;
      var i = Math.max(0, zoomSlides.indexOf(startSlide));
      var box = document.createElement('div');
      box.className = 'lp-lightbox';
      box.setAttribute('role', 'dialog');
      box.setAttribute('aria-modal', 'true');
      box.innerHTML = '<img alt=""><button type="button" class="lp-lightbox__close" aria-label="Close">✕</button>' +
        (zoomSlides.length > 1 ? '<button type="button" class="lp-lightbox__prev" aria-label="Previous">‹</button><button type="button" class="lp-lightbox__next" aria-label="Next">›</button>' : '') +
        '<span class="lp-lightbox__count"></span>';
      document.body.appendChild(box);
      var img = box.querySelector('img'), count = box.querySelector('.lp-lightbox__count');
      function show(n) {
        i = (n + zoomSlides.length) % zoomSlides.length;
        img.src = zoomSlides[i].dataset.zoom;
        var a = zoomSlides[i].querySelector('img');
        img.alt = a ? a.alt : '';
        count.textContent = (i + 1) + ' / ' + zoomSlides.length;
      }
      function close() {
        box.classList.remove('is-open');
        document.removeEventListener('keydown', onKey);
        setTimeout(function () { box.remove(); }, 350);
      }
      function onKey(e) {
        if (e.key === 'Escape') close();
        if (e.key === 'ArrowRight') show(i + 1);
        if (e.key === 'ArrowLeft') show(i - 1);
      }
      box.addEventListener('click', function (e) {
        if (e.target.closest('.lp-lightbox__prev')) show(i - 1);
        else if (e.target.closest('.lp-lightbox__next')) show(i + 1);
        else if (e.target === box || e.target.closest('.lp-lightbox__close')) close();
      });
      document.addEventListener('keydown', onKey);
      show(i);
      requestAnimationFrame(function () { box.classList.add('is-open'); box.querySelector('.lp-lightbox__close').focus(); });
    }
    if (track) {
      track.addEventListener('click', function (e) {
        var sl = e.target.closest('.lp-gallery__slide[data-zoom]');
        if (sl) openZoom(sl);
      });
      var zb = root.querySelector('[data-lp-zoom]');
      if (zb) {
        if (!zoomSlides.length) zb.hidden = true;
        zb.addEventListener('click', function () { openZoom(slides[activeIndex()]); });
      }
    }

    // ---- Price / state update ----
    function update(fromVariantChange) {
      var v = currentVariant();
      var tier = currentTier();

      optionSets.forEach(function (fs) {
        var c = fs.querySelector('input:checked');
        var label = fs.querySelector('[data-lp-option-value]');
        if (c && label) label.textContent = c.value;
      });

      if (!v) {
        atc.disabled = true;
        atcText.textContent = 'Unavailable';
        return;
      }

      idInput.value = v.id;
      qtyInput.value = tier.qty;

      var priceEl = root.querySelector('[data-lp-price]');
      var compareEl = root.querySelector('[data-lp-compare]');
      var saveEl = root.querySelector('[data-lp-save]');
      priceEl.textContent = money(v.price, cur);
      if (v.compare > v.price) {
        compareEl.textContent = money(v.compare, cur);
        saveEl.textContent = 'Save ' + Math.round((1 - v.price / v.compare) * 100) + '%';
        compareEl.hidden = saveEl.hidden = false;
      } else {
        compareEl.hidden = saveEl.hidden = true;
      }

      tierInputs.forEach(function (inp) {
        var q = parseInt(inp.value, 10), d = parseInt(inp.dataset.discount, 10) || 0, fr = parseInt(inp.dataset.free, 10) || 0;
        var label = inp.closest('.lp-tier');
        var total = (v.price - Math.floor(v.price * d / 100)) * Math.max(1, q - fr); /* same rounding as Shopify: discount floored per unit; free bags cost 0 */
        var full = (v.compare > v.price ? v.compare : v.price) * q;
        label.querySelector('[data-tier-price]').textContent = money(total, cur);
        var was = label.querySelector('[data-tier-was]');
        was.textContent = money(full, cur);
        was.hidden = full <= total;
      });

      atc.disabled = !v.available;
      var tierTotal = (v.price - Math.floor(v.price * tier.disc / 100)) * Math.max(1, tier.qty - (tier.free || 0));
      atcText.textContent = v.available ? (data.atcText || '').replace('[price]', money(tierTotal, cur)) : data.soldOutText;

      if (stockEl) {
        if (v.available && v.inv !== null && data.lowStock > 0 && v.inv > 0 && v.inv <= data.lowStock) {
          stockEl.textContent = (data.lowStockText || 'Only [count] left').replace('[count]', v.inv);
          stockEl.hidden = false;
        } else {
          stockEl.hidden = true;
        }
      }

      if (sticky) {
        var sp = sticky.querySelector('[data-lp-sticky-price]');
        if (sp) sp.textContent = money((v.price - Math.floor(v.price * tier.disc / 100)) * Math.max(1, tier.qty - (tier.free || 0)), cur);
        var si = sticky.querySelector('.lp-sticky__img');
        if (si) {
          if (!si.dataset.lpOrig) si.dataset.lpOrig = si.currentSrc || si.src;
          var nsrc = v.img || si.dataset.lpOrig;
          if (si.src !== nsrc) { si.src = nsrc; si.removeAttribute('srcset'); }
        }
        var sb = sticky.querySelector('[data-lp-sticky-btn]');
        if (sb) sb.disabled = !v.available;
      }

      if (fromVariantChange && track) {
        if (applyPack(v)) {
          /* card-specific gallery: start on its first item */
          goToEl(visSlides()[0], true);
          track.dispatchEvent(new Event('scroll'));
        } else {
          /* variant with its own image (e.g. 2 Toys pack photo) → show it; pack without one → back to the first slide */
          var idx = v.media ? Array.prototype.findIndex.call(slides, function (s) { return +s.dataset.mediaId === v.media; }) : (packs ? 0 : -1);
          if (idx > -1) goTo(idx, fromVariantChange === 'init');
        }
      }

      /* keep the chosen variant in the URL (shareable); the first paint of pack cards leaves it clean */
      if (fromVariantChange && fromVariantChange !== 'init' && window.history.replaceState) {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', v.id);
        window.history.replaceState({}, '', url.toString());
      }

      // Mark option values that have no available variant given other selections
      if (optionSets.length) {
        var sel = selectedOptions();
        optionSets.forEach(function (fs, oi) {
          fs.querySelectorAll('input').forEach(function (inp) {
            var test = sel.slice(); test[oi] = inp.value;
            var ok = data.variants.some(function (x) {
              return x.available && x.options.every(function (o, i) { return o === test[i]; });
            });
            var opt = inp.closest('.lp-pill, .lp-pack'); /* pill options or pack offer cards */
            if (opt) opt.classList.toggle('is-unavailable', !ok);
          });
        });
      }
    }

    optionSets.forEach(function (fs) {
      fs.addEventListener('change', function () { update(true); });
    });
    tierInputs.forEach(function (inp) { inp.addEventListener('change', function () { update(false); }); });
    if (tierInputs.length && !root.querySelector('.lp-tier input:checked')) tierInputs[0].checked = true;

    root.querySelectorAll('input[name^="lp-plan-"]').forEach(function (inp) {
      inp.addEventListener('change', function () {
        planInput.value = inp.value;
        planInput.disabled = !inp.value;
      });
      if (inp.checked && inp.value) { planInput.value = inp.value; planInput.disabled = false; }
    });

    // ---- Sticky bar: hidden while the main Buy button is on screen, shown as soon as it is out of view ----
    if (sticky && 'IntersectionObserver' in window) {
      var mqMobile = window.matchMedia('(max-width: 749px)');
      new IntersectionObserver(function (entries) {
        var e = entries[0];
        /* phones: out of view above or below (so a CTA is always in view); desktop: only once scrolled past */
        var show = !e.isIntersecting && (mqMobile.matches || e.boundingClientRect.top < 0);
        sticky.classList.toggle('is-visible', show);
        document.documentElement.classList.toggle('lp-sticky-on', show);
        sticky.setAttribute('aria-hidden', String(!show));
        var btn = sticky.querySelector('[data-lp-sticky-btn]');
        if (btn) btn.tabIndex = show ? 0 : -1;
      }, { threshold: 0.5 }).observe(atc);
    }

    // Submit: AJAX add + cart drawer when the LP header is installed, otherwise a normal form post
    var formEl = root.querySelector('.lp-form');
    var errEl = root.querySelector('[data-lp-error]');
    if (formEl) formEl.addEventListener('submit', function (e) {
      if (formEl.dataset.lpAjax === 'drawer' && window.LPCart && window.LPCart.el) {
        e.preventDefault();
        if (atc.disabled) return;
        atc.disabled = true;
        atc.classList.add('is-loading');
        if (errEl) errEl.hidden = true;
        var fd = new FormData(formEl);
        var item = { id: +fd.get('id'), quantity: +fd.get('quantity') || 1 };
        if (fd.get('selling_plan')) item.selling_plan = +fd.get('selling_plan');
        window.LPCart.add([item])
          .then(window.LPCart.afterAdd)
          .catch(function (err) {
            if (errEl) {
              errEl.textContent = (err && (err.description || err.message)) || 'Something went wrong. Please try again.';
              errEl.hidden = false;
            }
          })
          .then(function () { atc.classList.remove('is-loading'); update(false); });
        return;
      }
      setTimeout(function () { atc.disabled = true; }, 0); // prevent double submits
    });

    update(packs ? 'init' : false); /* pack cards: open the gallery on the default pack's own photo */
  }

  // "Order today, get it Wed, Oct 22 – Mon, Oct 27": real business-day estimate from the merchant's settings
  function addBusinessDays(d, n) {
    var x = new Date(d.getTime());
    while (n > 0) { x.setDate(x.getDate() + 1); var w = x.getDay(); if (w !== 0 && w !== 6) n--; }
    return x;
  }
  function initDelivery(el) {
    var min = parseInt(el.dataset.min, 10) || 5, max = Math.max(min, parseInt(el.dataset.max, 10) || min);
    var start = new Date();
    var cal = el.hasAttribute('data-calendar');
    var add = cal ? function (d, n) { var x = new Date(d.getTime()); x.setDate(x.getDate() + n); return x; } : addBusinessDays;
    if (!cal) {
      var left = secondsToCutoff(parseInt(el.dataset.cutoff, 10) || 14, el.dataset.tz || 'America/New_York');
      if (left === null) start = addBusinessDays(start, 1); // past today's cutoff or weekend → ships next business day
    }
    var fmt = new Intl.DateTimeFormat('en-US', { weekday: 'short', month: 'short', day: 'numeric' });
    var range = fmt.format(add(start, min)) + (max > min ? ' – ' + fmt.format(add(start, max)) : ''); /* same min/max → one date */
    var parts = (el.dataset.text || 'Order today, get it [dates]').split('[dates]');
    var t = el.querySelector('[data-lp-delivery-text]');
    t.textContent = parts[0];
    var b = document.createElement('strong'); b.textContent = range; t.appendChild(b);
    if (parts[1]) t.appendChild(document.createTextNode(parts[1]));
    el.hidden = false;
  }

  function init(scope) {
    (scope || document).querySelectorAll('[data-lp-delivery]').forEach(initDelivery);
    (scope || document).querySelectorAll('[data-lp-product]').forEach(initProduct);
    (scope || document).querySelectorAll('[data-lp-countdown]').forEach(initCountdown);
    // "Scroll to buy" links in other sections
    (scope || document).querySelectorAll('[data-lp-scroll-buy]').forEach(function (a) {
      a.addEventListener('click', function (e) {
        var target = document.querySelector('.lp-form');
        if (!target) return;
        e.preventDefault();
        target.scrollIntoView({ behavior: 'smooth', block: 'center' });
      });
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); });
  else init();

  // Re-init in the theme editor
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();

/* Buy it now: Shopify renders (and may re-render) this button itself, so add the dog icon once it appears */
(function () {
  document.querySelectorAll('[data-lp-buynow]').forEach(function (box) {
    var tpl = box.parentNode.querySelector('[data-lp-buynow-ico]');
    if (!tpl) return;
    function addIcon() {
      var btn = box.querySelector('.shopify-payment-button__button--unbranded');
      if (!btn || btn.querySelector('.lp-buynow__ico')) return;
      btn.classList.add('lp-nico-host');
      btn.appendChild(tpl.content.cloneNode(true));
    }
    addIcon();
    new MutationObserver(addIcon).observe(box, { childList: true, subtree: true });
  });
})();

/* Add-to-cart dog: carries a Minties bone to the bowl icon in the button, drops it in, celebrates, goes back for another */
(function () {
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  document.querySelectorAll('[data-lp-walker]').forEach(function (walker) {
    if (reduce || walker.dataset.lpInit) return; /* lp.js can be included by several sections */
    walker.dataset.lpInit = '1';
    var dog = walker.querySelector('.lp-walker__dog');
    var drop = walker.querySelector('.lp-walker__drop');
    var hearts = walker.querySelector('.lp-walker__hearts');
    var btn = walker.nextElementSibling;
    if (!dog || !btn || !btn.classList.contains('lp-atc')) return;
    var ico = btn.querySelector('.lp-atc__ico');
    var running = false, visible = false, hovering = false, timer = null, step = 0;
    var SPEED = 70; /* px per second */

    function geo() {
      var w = walker.getBoundingClientRect(), d = dog.getBoundingClientRect();
      var target = ico ? ico.getBoundingClientRect() : btn.getBoundingClientRect();
      var bowlX = target.left + target.width / 2 - w.left;
      var bowlY = target.top + target.height / 2 - w.top;
      var mouth = d.width * 0.84; /* where the bone sits, from the dog's left edge */
      return { w: w.width, dogW: d.width, dogH: d.height, bowlX: bowlX, bowlY: bowlY,
               stop: Math.max(0, Math.min(w.width - d.width, bowlX - mouth)), mouth: mouth };
    }
    function walkTo(x, cb) {
      var from = parseFloat(dog.style.left) || 0;
      var dur = Math.max(0.4, Math.abs(x - from) / SPEED);
      dog.classList.toggle('is-left', x < from);
      dog.classList.add('is-walking');
      dog.style.transitionDuration = dur + 's';
      dog.style.left = x + 'px';
      wait(dur * 1000, function () { dog.classList.remove('is-walking'); cb(); });
    }
    function wait(ms, cb) { timer = setTimeout(function () { timer = null; if (running) cb(); else pending = cb; }, ms); }
    var pending = null;

    function loop() {
      var g = geo();
      step++;
      /* 1. trot to the bowl with the bone */
      dog.classList.remove('no-bone');
      walkTo(g.stop, function () {
        /* 2. dip the head and drop the bone into the bowl */
        dog.classList.add('is-dropping');
        wait(260, function () {
          var gg = geo();
          dog.classList.add('no-bone');
          drop.style.left = (gg.stop + gg.mouth - 8) + 'px';
          drop.style.top = (gg.dogH * 0.42) + 'px';
          drop.style.setProperty('--dy', (gg.bowlY - gg.dogH * 0.42 - 6) + 'px');
          drop.classList.remove('is-falling'); void drop.offsetWidth; drop.classList.add('is-falling');
          wait(520, function () {
            /* 3. the bowl fills up, the dog is happy */
            btn.classList.add('is-fed');
            dog.classList.remove('is-dropping');
            dog.classList.add('is-happy');
            hearts.style.left = (gg.stop + gg.dogW * 0.55) + 'px';
            hearts.classList.remove('is-on'); void hearts.offsetWidth; hearts.classList.add('is-on');
            wait(1500, function () {
              btn.classList.remove('is-fed');
              dog.classList.remove('is-happy');
              /* 4. trot back to fetch another bone */
              walkTo(0, function () {
                dog.classList.add('is-fetching');
                wait(500, function () {
                  dog.classList.remove('is-fetching', 'no-bone', 'is-left');
                  wait(900, loop);
                });
              });
            });
          });
        });
      });
    }
    function setRunning() {
      var should = visible && !hovering;
      if (should === running) return;
      running = should;
      walker.classList.toggle('is-paused', !running);
      if (running && pending) { var cb = pending; pending = null; cb(); }
    }
    btn.addEventListener('mouseenter', function () { hovering = true; setRunning(); });
    btn.addEventListener('mouseleave', function () { hovering = false; setRunning(); });
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (es) { visible = es[0].isIntersecting; setRunning(); if (running && step === 0) loop(); }).observe(walker);
    } else { visible = true; setRunning(); loop(); }
  });
})();

/* Add-to-cart cat: a feather pops out of the button at random spots (like the Ambush);
   the cat stalks it, crouches, pounces – the feather usually hides just in time, sometimes it gets caught. */
(function () {
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  document.querySelectorAll('[data-lp-cat]').forEach(function (box) {
    if (reduce || box.dataset.lpInit) return; /* lp.js can be included by several sections */
    box.dataset.lpInit = '1';
    var cat = box.querySelector('.lp-walker__dog');
    var slot = box.querySelector('.lp-walker__slot');
    var btn = box.nextElementSibling;
    if (!cat || !slot) return;
    box.classList.add('is-hunting');
    var running = false, visible = false, hovering = false, pending = [], started = false, tries = 0;
    var SPEED = 190; /* px/s – a quick sprint, not a stroll */

    function wait(ms, cb) { setTimeout(function () { if (running) cb(); else pending.push(cb); }, ms); }
    function setState(st) { cat.classList.remove('is-walking', 'is-crouch', 'is-pounce', 'is-look', 'is-happy'); if (st) cat.classList.add(st); }
    function catLeft() { return parseFloat(cat.style.left) || 0; }
    function move(x, dur, st, cb) {
      cat.style.transitionDuration = dur + 's';
      cat.style.left = x + 'px';
      setState(st);
      wait(dur * 1000, cb);
    }

    function hunt() {
      var W = box.clientWidth, cw = cat.offsetWidth, sw = slot.offsetWidth;
      var cur = catLeft() + cw / 2, fx;
      /* new hiding spot: far enough from the cat */
      for (var i = 0; i < 12; i++) { fx = sw + Math.random() * (W - 2 * sw); if (Math.abs(fx - cur) > W * 0.3) break; }
      slot.style.left = (fx - sw / 2) + 'px';
      slot.classList.add('is-up');
      var right = fx > cur;
      cat.classList.toggle('is-left', !right);
      /* front paws sit ~66% into the cat on the side it faces */
      var paw = right ? cw * 0.66 : cw * 0.34;
      var target = fx - paw, stalkAt = right ? target - cw * 0.45 : target + cw * 0.45;
      stalkAt = Math.max(0, Math.min(W - cw, stalkAt));
      setState('is-look');
      wait(160, function () {
        move(stalkAt, Math.max(0.28, Math.abs(stalkAt - catLeft()) / SPEED), 'is-walking', function () {
          setState('is-crouch');                       /* quick butt wiggle */
          wait(380, function () {
            tries++;
            var caught = tries % 2 === 0;
            move(Math.max(0, Math.min(W - cw, target)), 0.3, 'is-pounce', function () {
              if (caught) {
                setState('is-happy');                  /* got it! */
                slot.classList.add('is-caught');
                wait(800, function () { slot.classList.remove('is-up', 'is-caught'); setState('is-look'); wait(250, hunt); });
              } else {
                setState('is-look');                   /* where did it go? */
                wait(280, hunt);
              }
            });
            if (!caught) wait(190, function () { slot.classList.remove('is-up'); });  /* hides just in time */
          });
        });
      });
    }

    function setRunning() {
      var should = visible && !hovering;
      if (should === running) return;
      running = should;
      box.classList.toggle('is-paused', !running);
      if (running && !started) { started = true; hunt(); }
      else if (running && pending.length) { var q = pending; pending = []; q.forEach(function (cb) { cb(); }); }
    }
    if (btn) {
      btn.addEventListener('mouseenter', function () { hovering = true; setRunning(); });
      btn.addEventListener('mouseleave', function () { hovering = false; setRunning(); });
    }
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (es) { visible = es[0].isIntersecting; setRunning(); }).observe(box);
    } else { visible = true; setRunning(); }
  });
})();


/* Review cards under the price: arrows + gentle auto-advance */
(function () {
  document.querySelectorAll('[data-lp-rcards]').forEach(function (box) {
    if (box.dataset.lpInit) return; box.dataset.lpInit = '1';
    var track = box.querySelector('[data-lp-rcards-track]');
    var cards = track ? track.children : [];
    if (!track || cards.length < 2) { box.classList.add('is-single'); return; }
    function step(dir) {
      var w = cards[0].getBoundingClientRect().width + 12;
      var max = track.scrollWidth - track.clientWidth - 2;
      var next = track.scrollLeft + dir * w;
      if (next > max + 4) next = 0; else if (next < -4) next = max;
      track.scrollTo({ left: next, behavior: 'smooth' });
    }
    box.querySelector('[data-lp-rcards-prev]').addEventListener('click', function () { step(-1); });
    box.querySelector('[data-lp-rcards-next]').addEventListener('click', function () { step(1); });
    var timer = setInterval(function () { if (!box.matches(':hover')) step(1); }, 5500);
    track.addEventListener('pointerdown', function () { clearInterval(timer); }, { once: true });
  });
})();

/* Review card videos: play muted, tap to turn the sound on/off */
document.addEventListener('click', function (e) {
  var box = e.target.closest && e.target.closest('.lp-rcard__media--video');
  if (!box) return;
  var v = box.querySelector('video'); if (!v) return;
  v.muted = !v.muted; if (v.paused) v.play();
  var s = box.querySelector('.lp-rcard__sound'); if (s) s.textContent = v.muted ? '🔇' : '🔊';
});
